import React, { useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { Title, Form, Text, Input, Button, Loading } from 'ui';
import { inviteUser, useCompany, useCompanyUsers, useInvites } from 'api';
import "./index.css";


export default function InviteContributor() {
  
  const history = useHistory();
  const match = useRouteMatch();
  const companyId = match.params.companyId;
  const [email, setEmail] = useState("");
  const company = useCompany(companyId);
  const users = useCompanyUsers(companyId);
  const invites = useInvites(companyId);
  
  if(!company || !users || !invites) {
    return <Loading/>;
  }
  
  function save() {
    inviteUser(email, companyId);
    history.push('view');
  }
  
  function cancel() {
    history.push('view');
  }
  
  const seats = company.plan.seats || 5;
  const used = users.length + invites.length;
  if(used >= seats) {
    return (
      <div className="inviteuser">
        <Title>Invite Contributor</Title>
        <Text>
          Your <strong>{company.plan.name}</strong> plan only allows <strong>{seats}</strong> seats.<br/>
          Please upgrade your account before sending more invitations.
        </Text>
        <div className="inviteuser-actions">
          <Button label="Ok" onClick={cancel}/>
        </div>
      </div>
    );
  }
  
  return (
    <Form onSubmit={save} className="inviteuser">
    
      <Title>Invite Contributor</Title>
    
      <Input 
        value={email}
        onChange={setEmail}
        label="Email Address"
      />
        
      
      <div className="inviteuser-actions">
        <Button label="Send Invitation" submit/>
        <Button tertiary label="Cancel" onClick={cancel}/>
      </div>
      
    </Form>
  );
}